import styled from 'styled-components';
import colors from '../../theme/colors';

const ReviewWrapper = styled.div`
  background: #fff;
  padding: 12px 20px;
  font-size: 14px;
  margin-bottom: 16px;
`;

const ReviewWrapperHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 8px;
`;

const ReviewWrapperFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const ReviewWrapperTitle = styled.div`
  color: ${colors.blue};
  font-weight: 700;
  font-size: 15px;
  font-family: Poppins;
`;

const ReviewWrapperAuhtor = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  font-size: 13px;
`;

const ReviewWrapperDate = styled.div`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
`;

export {
  ReviewWrapper,
  ReviewWrapperHeader,
  ReviewWrapperFooter,
  ReviewWrapperTitle,
  ReviewWrapperAuhtor,
  ReviewWrapperDate,
};
